import script from "./reservationEntrust.vue?vue&type=script&setup=true&lang=js"
export * from "./reservationEntrust.vue?vue&type=script&setup=true&lang=js"

import "./reservationEntrust.vue?vue&type=style&index=0&id=48fe2c58&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48fe2c58"]])

export default __exports__